import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';

import s from './ProfileHeroFTUE.scss';

export interface Props {
  className?: string;
  isDeviationSet: boolean;
  hideProfileHeroAid(): void;
  openIntroPopup(): void;
  isReducedHero?: boolean;
  showProfileEditAid?: boolean;
}

class ProfileHeroFTUE extends React.Component<Props & WithTranslation> {
  render() {
    if (this.props.isDeviationSet) {
      return null;
    }

    const {
      className,
      isReducedHero,
      showProfileEditAid,
      hideProfileHeroAid,
      openIntroPopup,
      t,
    } = this.props;
    return (
      <div
        className={classnames(
          s['root'],
          isReducedHero && s['is-reduced'],
          className
        )}
      >
        <div className={s['content']}>
          <div className={s['title']}>
            {t('common.profileHero.empty.title')}
          </div>
          <div className={s['subtitle']}>
            {t('common.profileHero.empty.subtitle')}
          </div>
          <div className={s['buttons']}>
            <Button
              view="b34"
              height="medium"
              onClick={hideProfileHeroAid}
              data-role="ftue-control"
            >
              {t('common.profileHero.empty.gotIt')}
            </Button>
            {showProfileEditAid && (
              <Button
                view="b14-1"
                height="medium"
                onClick={openIntroPopup}
                data-role="ftue-control"
              >
                {t('common.profileHero.empty.watchIntro')}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ProfileHeroFTUE);
